import React, { useState, useEffect, useMemo, useContext,  Fragment } from 'react';
import { SOCIAL_MEDIA_LINKS, SOCIAL_MEDIA_LOGOS, SOCIAL_MEDIA_TYPE, STYLE_TYPE, contact, SOCIAL_MEDIA_LOGOS_WHITE, homePageContact } from '../../Utils/magicStrings';
import { HeaderPictureWrapper, Logo, SocialMediaWrapper, 
    SocialMediaLogo, MenuWrapper, MenuLine, MenuWord,
     MenuWindowWrapper, MenuClose, MenuTitle, MenuSubTitle,
     MenuArrow,
     Background,
     Title, 
} from './HeaderStyle';
import { Modal } from '../Modal/Modal';
import { styleContextApp } from '../../Pages/StyleContext';
import { ARROW_STYLE, POINT_STYLE, Swiper } from '../Swiper/Swiper';
import { ContactIconWrapper } from '../../Pages/Home/HomeStyle';
import arrow from './Arrow.png';
import icon from './icon.png';
import { Link, useNavigate } from 'react-router-dom';
import { WechatWindow } from '../../Pages/Reserve/ReserveStyle';
import wechat from '../../Pages/Reserve/wechat.png';



export function Header({ styleType, title,  pictures, hasMarginTop, headerHeight, mobileHeight, hasClick }) {
    return (
        <Fragment>
            <MenuEle styleType={styleType} hasMarginTop={hasMarginTop}/>
            <HeaderPicture 
                title={title}
                pictures={pictures}
                styleType={styleType}
                hasMarginTop={hasMarginTop}
                height={headerHeight}
                mobileHeight={mobileHeight}
                hasClick={hasClick}
            />
        </Fragment>
    );
}

const MenuWindow = ({styleType, setShowMenu}) => {
    const  navigate  = useNavigate();
    const jumpTo = (aim) => {
        setShowMenu(false);
        const gap = styleType === STYLE_TYPE.MOBILE ? 62 : 32;
        if(document.getElementById(aim)) {
            document.documentElement.scrollTop = document.getElementById(aim).getBoundingClientRect().y + window.scrollY - (gap);
        } else {
            navigate(`/`, {state: {aim, gap}});
        }
    }

    const [showWechat, setShowWechat] = useState(false);
    const toShowWechat = () => {
        setShowWechat(true);
    }
    const wechatElement = useMemo(() => {
        return (
            <WechatWindow styleType={styleType} setShowMenu={setShowWechat} >
                <img src={wechat} alt=''></img>
            </WechatWindow>
        )
    }, [styleType]);

    return (
        <MenuWindowWrapper styleType={styleType}>
            <MenuClose 
                styleType={styleType}
                onClick={() => setShowMenu(false)}
            >
                <div id='left'/><div id='right'/>
            </MenuClose>
            <MenuTitle styleType={styleType} top={121} mobileTop={57} onClick={() => jumpTo('about')}>the difference</MenuTitle>
            <MenuSubTitle styleType={styleType} top={174} mobileTop={90} onClick={() => jumpTo('about')}>甄選標準</MenuSubTitle>
            <MenuTitle styleType={styleType} top={220} mobileTop={138} onClick={() => jumpTo('added')}>just added</MenuTitle>
            {/* <SubTitleWrapper styleType={styleType} /> */}
            {/* <MenuSubTitle styleType={styleType} left={145} top={345} mobileTop={246} mobileLeft={51} onClick={() => jumpTo('select')}>巡旅精选</MenuSubTitle>
            <MenuSubTitle styleType={styleType} left={145} top={375} mobileTop={274} mobileLeft={51} onClick={() => jumpTo('new')}>巡旅上新</MenuSubTitle> */}
            <MenuSubTitle styleType={styleType} top={273} mobileTop={172} mobileLeft={32} onClick={() => jumpTo('added')}>新入選旅舍</MenuSubTitle>
            <MenuTitle styleType={styleType} top={319} mobileTop={217} onClick={() => jumpTo('country')}>countryside detinations</MenuTitle>
            <MenuSubTitle styleType={styleType} top={372} mobileTop={250} mobileLeft={32} onClick={() => jumpTo('country')}>鄉野目的地</MenuSubTitle>
            <MenuTitle styleType={styleType} top={418} mobileTop={302} onClick={() => jumpTo('find')}>curated collections</MenuTitle>
            <MenuSubTitle styleType={styleType} top={471} mobileTop={332} mobileLeft={32} onClick={() => jumpTo('find')}>精選系列</MenuSubTitle>
            <MenuTitle styleType={styleType} top={517} mobileTop={384} onClick={() => jumpTo('qa')}>about us</MenuTitle>
            <MenuSubTitle styleType={styleType} top={570} mobileTop={414} onClick={() => jumpTo('qa')}>何為日本巡旅？</MenuSubTitle>
            <MenuTitle styleType={styleType} top={622} mobileTop={475}>
                <ContactIconWrapper styleType={styleType} marginLeft={styleType === STYLE_TYPE.MOBILE ? 14: 22} noMargin={true} width={styleType === STYLE_TYPE.MOBILE ? 21 : 28}>
                    {homePageContact.map(e => {
                        return <img data-src={SOCIAL_MEDIA_LOGOS[e]} className='lazyload' alt='' key={e} id={e} onClick={()=>
                            {if(e !== SOCIAL_MEDIA_TYPE.WECHAT) {
                             window.open(SOCIAL_MEDIA_LINKS[e]);
                            } else {
                                toShowWechat();
                            }}
                        }/>
                    }) }
                </ContactIconWrapper>
            </MenuTitle>
            <MenuArrow styleType={styleType}>
                <span>探索旅舍</span>
                <img src={arrow} alt=''></img>
            </MenuArrow>
            { showWechat && <Modal positionType={'middle'} modalElement={wechatElement} setModalOpen={setShowWechat} backdropClose={true}/>}
        </MenuWindowWrapper>
    )
}
const MenuEle = ({styleType, hasMarginTop}) => {
    const [ color, setColor ] = useState('white');
    const [ showMenu, setShowMenu ] = useState(false);
    const checkColor = () => {
        if(document.documentElement.scrollTop > document.getElementById('header')?.offsetHeight) {
            setColor('black');
        } else {
            setColor('white');
        }
    }
    useEffect(() => {
        document.addEventListener('scroll', checkColor);
        return () => {
            document.removeEventListener('scroll', checkColor);
        }
    }, []);

    const modal = useMemo(() => {
        return (<Modal positionType={'leftTop'} modalElement={<MenuWindow styleType={styleType} setShowMenu={setShowMenu} />} setModalOpen={() => setShowMenu(false)} backdropClose={true} ></Modal>)
    }, [styleType]);
    return (
        <Fragment>
            <MenuWrapper styleType={styleType} id='menu' onClick={() => setShowMenu(true)} hasMarginTop={hasMarginTop}>
                <MenuLine styleType={styleType} color={color}>
                    <div/><div/><div/>
                </MenuLine>
                {styleType !== STYLE_TYPE.MOBILE && <MenuWord color={color} styleType={styleType}>
                    MENU
                </MenuWord>}
            </MenuWrapper>
            { showMenu && modal}
        </Fragment>
    )
};

const HeaderPicture = ({pictures, title, hasMarginTop, height=863, mobileHeight=617, hasClick}) => {

    const styleType = useContext(styleContextApp);
    const socialMedia = [SOCIAL_MEDIA_TYPE.FACEBOOK, SOCIAL_MEDIA_TYPE.WEIBO, SOCIAL_MEDIA_TYPE.WECHAT];
    const navigate = useNavigate();
    const [showWechat, setShowWechat] = useState(false);
    const toShowWechat = () => {
        setShowWechat(true);
    }
    const wechatElement = useMemo(() => {
        return (
            <WechatWindow styleType={styleType} setShowMenu={setShowWechat} >
                <img src={wechat} alt=''></img>
            </WechatWindow>
        )
    }, [styleType]);
    const pictureElements = pictures.map((e,index) => {
        console.log(pictures);
        return (
            <div className='wrapper' onClick={() => {
                if(hasClick && hasClick[index]) {navigate(`/detail/${hasClick[index]}`)}
            }}
                key={index} 
                style={{display: 'inline-block', position: 'relative', width: '100%', height: '100%', overflow: 'hidden'}} >
                <img src={e} className='lazyload' alt='' style={{height: '100%', position: 'absolute', left: '50%', transform: 'translate(-50%)' , width: styleType === STYLE_TYPE.MOBILE ? 'auto' : '100%'}}  />
                <Background styleType={styleType}/>
            
            </div>
        )
    });

    return (
        <HeaderPictureWrapper styleType={styleType} id={'header'} hasMarginTop={hasMarginTop}>
            <Swiper 
                height={styleType === STYLE_TYPE.MOBILE ? (mobileHeight || 617) : height} 
                isAutoPlay={true} 
                pointStyle={styleType === STYLE_TYPE.MOBILE ? POINT_STYLE.POINT_IN :POINT_STYLE.CIRCLE_COLUMN} 
                arrowStyle={ARROW_STYLE.NONE}  
                elements={pictureElements} 
                isLoop={true} 
                hasArrow={false}
                hasClick={hasClick}
            />
            <Link to='/'>
            <Logo styleType={styleType} hasMarginTop={hasMarginTop}>
                <img alt='' src={icon} ></img>
            </Logo>
            </Link>
            <Title  styleType={styleType}>
                {title}
            </Title>
            <SocialMediaWrapper styleType={styleType} hasMarginTop={hasMarginTop}>
                {socialMedia.map(ele => {
                    return (
                        <SocialMediaLogo id={ele} styleType={styleType} key={ele} onClick={() => {
                            if(ele === SOCIAL_MEDIA_TYPE.WECHAT) {
                                setShowWechat(true);
                            } else {
                                window.open(SOCIAL_MEDIA_LINKS[ele]);
                            }
                        }}>
                            <img  className='lazyload' data-src={SOCIAL_MEDIA_LOGOS_WHITE[ele]} alt=''/>
                        </SocialMediaLogo>
                    )
                })}
                
            </SocialMediaWrapper>
            { showWechat && <Modal positionType={'middle'} modalElement={wechatElement} setModalOpen={setShowWechat} backdropClose={true}/>}
        </HeaderPictureWrapper>
    );
};